import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, TrendingUp, MoreHorizontal } from 'lucide-react';
import { useGeo } from '../contexts/GeoContext';

const MobileNav = ({ onOpenMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const { isBrazil } = useGeo();

  const items = [
    { key: 'home', icon: Home, label: isBrazil ? 'Inicio' : 'Home', path: '/' },
    { key: 'shop', icon: ShoppingBag, label: isBrazil ? 'Loja' : 'Shop', path: '/' },
    { key: 'status', icon: TrendingUp, label: 'Status', path: '/status' },
    { key: 'more', icon: MoreHorizontal, label: isBrazil ? 'Mais' : 'More', action: 'menu' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-testid="mobile-nav">
      <div className="bg-gray-950/95 backdrop-blur-xl border-t border-gray-800/60">
        <div className="flex items-center justify-around px-2 py-2">
          {items.map((item) => {
            const isActive = item.path ? path === item.path : false;
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                onClick={() => item.action === 'menu' ? onOpenMenu() : navigate(item.path)}
                className={`flex flex-col items-center gap-0.5 py-1.5 px-3 rounded-xl transition-all ${
                  isActive
                    ? 'text-white bg-white/10'
                    : 'text-gray-500 active:text-white active:bg-white/5'
                }`}
                data-testid={`mobile-nav-${item.key}`}
              >
                <Icon className={`w-5 h-5 ${isActive ? 'text-red-500' : ''}`} strokeWidth={isActive ? 2.5 : 1.5} />
                <span className={`text-[10px] font-medium ${isActive ? 'text-white' : ''}`}>{item.label}</span>
              </button>
            );
          })}
        </div>
        {/* Safe area for phones with gesture bar */}
        <div className="h-[env(safe-area-inset-bottom)]" />
      </div>
    </nav>
  );
};

export default MobileNav;
